import Firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE,
  authDomain: "lights-out2.firebaseapp.com",
  projectId: "lights-out2",
  storageBucket: "lights-out2.appspot.com",
  messagingSenderId: "956145197060",
  appId: "1:956145197060:web:9c79bf07a365dc9b789551",
  measurementId: "G-F4JE4G57D2"
};

const firebase = Firebase.initializeApp(config);
const provider = new Firebase.auth.GoogleAuthProvider();
const { FieldValue } = Firebase.firestore;



export { firebase, provider, FieldValue };
